{
  "title": "الجنسيات",
  "add": "إضافة جنسية",
  "edit": "تعديل الجنسية",
  "columns": {
    "nameAr": "الاسم بالعربية",
    "nameEn": "الاسم بالإنجليزية"
  },
  "fields": {
    "nameAr": "الاسم بالعربية",
    "nameEn": "الاسم بالإنجليزية"
  },
  "deleteConfirm": {
    "title": "حذف {{name}}؟",
    "description": "ستختفي هذه الجنسية من قوائم الـ PDA، وتحتفظ العمليات المسجلة بها باسمها."
  },
  "toasts": {
    "created": "تم إنشاء الجنسية بنجاح",
    "updated": "تم تحديث الجنسية بنجاح",
    "deleted": "تم حذف الجنسية بنجاح"
  },
  "empty": "لا توجد بيانات متاحة"
}
